import { assignRole } from '@/api/user-role-api'
import {
  API_SUCCESS,
  API_PENDING,
  API_FAILURE,
  RESET_INITIAL_STATE,
  INTERNAL_SERVER_ERROR,
  UNPROCESSABLE_ENTITY,
} from '@/constants/Actions'

export type UserManagementState = {
  loading: boolean
  error: boolean
  errorType: string
  errorMessage: string
  success: boolean
  successMessage: string
}

export const userManagementInitialState: UserManagementState = {
  loading: true,
  error: false,
  errorType: '',
  errorMessage: '',
  success: false,
  successMessage: '',
}

export type UserManagementAction =
  | { type: typeof API_PENDING }
  | { type: typeof API_FAILURE; payload: { type: string; message: string } }
  | { type: typeof API_SUCCESS; payload: { message: string } }
  | { type: typeof RESET_INITIAL_STATE }

export const userManagementReducer = (
  state: UserManagementState,
  action: UserManagementAction,
): UserManagementState => {
  const { type } = action

  switch (type) {
    case API_PENDING:
      return {
        ...state,
        loading: true,
        error: false,
        errorType: '',
        errorMessage: '',
        success: false,
        successMessage: '',
      }
    case API_FAILURE:
      if ('payload' in action) {
        return {
          ...state,
          loading: false,
          error: true,
          errorType: action.payload.type,
          errorMessage: action.payload.message,
        }
      }
      return state
    case API_SUCCESS:
      if ('payload' in action) {
        return {
          ...state,
          loading: false,
          success: true,
          successMessage: action.payload.message,
        }
      }
      return state
    case RESET_INITIAL_STATE:
      return {
        ...state,
        loading: false,
        error: false,
        success: false,
        successMessage: '',
        errorMessage: '',
      }
    default:
      return state
  }
}

export const userManagementActions = {
  updateRole:
    (data: any) => async (dispatch: (action: UserManagementAction) => void) => {
      dispatch({ type: API_PENDING })
      try {
        await assignRole(data).then((response) => {
          if (!response) {
            throw {
              message: 'Failed to send data. Please check your network.',
              type: 'API/Network failure',
            }
          } else if (response.data.status === INTERNAL_SERVER_ERROR) {
            throw {
              message: 'Failed to assign role.',
              type: response.data.message,
            }
          } else if (response.data.httpStatus === UNPROCESSABLE_ENTITY) {
            throw {
              message: response.data.message,
            }
          }
        })
        dispatch({
          type: API_SUCCESS,
          payload: { message: 'Update role successfully' },
        })
      } catch (error) {
        dispatch({
          type: API_FAILURE,
          payload: { type: 'API_ERROR', message: 'Failed to submit' },
        })
      }
    },
}
